<template>
  <div class="view version">
    <div class="container">
      <div class="title">Version</div>
      <div class="line">
        <span class="line-title">FRONT:</span>
        <span>v{{ version }}</span>
      </div>
      <div class="line">
        <span class="line-title">BACK:</span>
        <span>v{{ '0.0.0' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  data() {
    return {
      version: config.BUILD_VERSION,
    };
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.view {
  background: colors.$main-color;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    max-width: calc(100% - 32px);
    width: 590px;
    height: auto;
    padding: 64px 96px;
    box-sizing: border-box;
    background: colors.$white-color;
    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(colors.$darkblue-color, 0.2);

    @media screen and (max-width: 700px) {
      padding: 48px 32px;
    }

    .title {
      font-family: fonts.$title-font;
      color: colors.$darkblue-color;
      font-size: 24px;
      font-weight: 600;
      text-align: left;
      margin: 0 0 32px;
    }

    .line {
      margin: 0 0 4px 0;

      &:last-child {
        margin-bottom: 0;
      }

      .line-title {
        display: inline-block;
        width: 56px;
        color: colors.$darkblue-color;
        font-size: 16px;
        font-weight: 500;
        margin: 0 8px 0 0;
      }
    }
  }
}
</style>
